import React, {useReducer, useEffect } from "react";
import informesContext from "./informesContext.js";
import informesReducer from "./informesReducer.js";
import * as XLSX from 'xlsx';

//Types
import { 
    ACTUALIZAR_LIST_INFORMES,
  } from "./informesActions";
import { RamenDiningRounded } from "@mui/icons-material";

const InformesState = props =>{
     
    const initialState = {
        tipoInforme:'xls',
        informesList: null
    };

    const [state, dispatch] = useReducer(informesReducer, initialState);

    const getOTsModeladasReporte = async() => {
    }

    const generarInformeExcel = async(arrayToExcel, entityName) =>{
        const ws = XLSX.utils.aoa_to_sheet(arrayToExcel);
        
        const headerStyle = {
            font: {bold: true}, //, color: {rgb: "FFFFFF"}
            //fill: {fgColor: {rgb: "3D4D87"}},
            alignment: {horizontal: "center", vertical: "center"}
        }

        const range = XLSX.utils.decode_range(ws['!ref']);

        for(let col = range.s.c; col <= range.e.c; col++){
            const cellAddress = XLSX.utils.encode_cell({r:0, c:col});
            if(!ws[cellAddress]) continue;
            ws[cellAddress].s = headerStyle;
        }

        for(let row = range.s.r + 1; row <= range.e.r; row++){
            for(let col = range.s.c; col <= range.e.c; col++){
                const cellAddress = XLSX.utils.encode_cell({r: row, c: col});
                if(!ws[cellAddress]) continue;
                if(typeof ws[cellAddress].v === 'number'){
                    ws[cellAddress].z = '#,##0.##';
                }
            }
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'OTs');

        XLSX.writeFile(wb, `${entityName}.xlsx`);
        return true
    }

    useEffect(() => {
        //Evaluar si debe quedar aca o en la vista Informes cada vez que es renderizada.
        getOTsModeladasReporte()
    },[])

    return(
        <informesContext.Provider value={{ getOTsModeladasReporte, generarInformeExcel }}>
            {props.children}
        </informesContext.Provider>
    )

}

export default InformesState;